import type { CommunicationsDetailsDocument, DocumentCommunicationDetails } from '@izimi/api';

import BaseCommunicationDetailsEntity from './BaseCommunicationDetailsEntity';

/**
 * @deprecated Entity classes are being removed. Use the generated `BoxDocumentCommunicationDetails`
 * type from `@fednot/certinot-api` together with the helpers in `communications/helpers.ts`.
 */
class CommunicationDetailsEntity extends BaseCommunicationDetailsEntity {
  readonly documents: Array<CommunicationsDetailsDocument>;

  constructor(communicationDetails: DocumentCommunicationDetails, collection?: string) {
    super(communicationDetails, collection);
    this.documents = communicationDetails.documents ?? [];
  }

  get hasImportantDocuments() {
    return this.documents.some((document) => document.isImportant);
  }

  get hasAvailableDocuments() {
    return this.documents.some((document) => document.isAvailable);
  }

  get availableDocumentIds() {
    if (!this.hasAvailableDocuments) return [];
    return this.documents
      .filter((document) => document.isAvailable)
      .map((document) => document.documentId);
  }

  get isFolder() {
    return (this.documents.length ?? 0) > 1;
  }

  getAvailableDocumentCounts() {
    const { importantDocumentsCount, documentsCount } = this.documents.reduce(
      (acc, { isImportant, isAvailable }) => {
        if (!isAvailable) return acc;

        if (isImportant) {
          acc.importantDocumentsCount++;
        } else {
          acc.documentsCount++;
        }

        return acc;
      },
      { importantDocumentsCount: 0, documentsCount: 0 },
    );

    return { importantDocumentsCount, documentsCount };
  }
}

export default CommunicationDetailsEntity;
